import { createContext, useContext, useEffect } from "react";

// Ширина робочої області. Дефолт — reading-cap (`--layout-content-max`, 1440px,
// центровано), комфортний для форм/карток. Дата-щільні сторінки (канбан-дошка)
// опціонально просять full-bleed (вся ширина екрана) → на великому моніторі
// влазить більше колонок/елементів.
export interface LayoutWidthValue {
  wide: boolean;
  setWide: (wide: boolean) => void;
}

export const LayoutWidthContext = createContext<LayoutWidthValue>({
  wide: false,
  setWide: () => {},
});

// Сторінка декларує бажану ширину робочої області. Скидається на дефолт (cap)
// при анмаунті або зміні прапора (напр. перемикання Канбан↔Таблиця).
// Поза AppLayout (юніт-тест сторінки) — no-op через дефолтний контекст.
export function useContentWidth(wide: boolean): void {
  const { setWide } = useContext(LayoutWidthContext);
  useEffect(() => {
    setWide(wide);
    return () => setWide(false);
  }, [wide, setWide]);
}
